var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnExcluir)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button ml-1",attrs:{"title":"Excluir Mensagem"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluir()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }